import { useEffect, useState } from 'react'
import { TriangleAlert } from 'lucide-react'
import { vistaDeDireccion } from '@/features/rh/api/vistaDeDireccion'
import {
  avisoDeEntrevistasPendientes,
  entrevistasPendientes,
} from '@/features/rh/lib/vistaDeDireccion'

/**
 * Advertencia al decidir con entrevistas de Dirección sin resultado (SRH-312).
 *
 * Advierte y no bloquea: decidir es legítimo, pero esas entrevistas se cancelan
 * solas y conviene que quien decide lo sepa antes de confirmar. Si no hay
 * ninguna, o la consulta falla, no se pinta nada: la decisión no depende de esto.
 *
 * Al registrar el resultado de una entrevista se pasa su id, para no contarla:
 * es la que decide.
 */
export const AvisoDeEntrevistasPendientes = ({
  candidateId,
  exceptoId,
}: {
  candidateId: string
  exceptoId?: number
}) => {
  const [aviso, setAviso] = useState('')

  useEffect(() => {
    let vigente = true
    vistaDeDireccion
      .entrevistasDe(candidateId)
      .then((lista) => {
        if (vigente) setAviso(avisoDeEntrevistasPendientes(entrevistasPendientes(lista, exceptoId)))
      })
      .catch(() => vigente && setAviso(''))
    return () => {
      vigente = false
    }
  }, [candidateId, exceptoId])

  if (!aviso) return null

  return (
    <p
      role="alert"
      className="mt-4 flex items-start gap-2 rounded-lg bg-[#FEF6E2] px-3 py-2.5 text-sm text-[#795E1B]"
    >
      <TriangleAlert className="w-4 h-4 flex-shrink-0 mt-0.5" />
      {aviso}
    </p>
  )
}
